import styled from 'styled-components';

const SpinnerContainer = styled.div<{ size: number; color: string }>`
  > div {
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    background-color: ${({ color }) => `var(--${color})`};

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .bounce1 {
    animation-delay: -0.32s;
  }

  .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0.2);
    }
    40% {
      transform: scale(0.5);
    }
  }
`;

type Props = {
  size?: number;
  className?: string;
  colorToken?: string;
  ariaLabel?: string;
};

const EllipsisSpinner = ({
  size = 12,
  className,
  colorToken = 'color-neutral-500',
  ariaLabel = 'loading indicator',
}: Props) => {
  return (
    <SpinnerContainer
      size={size}
      className={className}
      color={colorToken}
      aria-label={ariaLabel}
    >
      <div className="bounce1" />
      <div className="bounce2" />
      <div />
    </SpinnerContainer>
  );
};

export default styled(EllipsisSpinner)``;
